import React from 'react';
import CreateProtocolForm from '../components/CreateProtocolForm';
import './CreateProtocolPage.scss';

const CreateProtocolPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <CreateProtocolForm />
      </div>
    </div>
  );
};

export default CreateProtocolPage;
